  <main id="main">
  <i (click)="mob_click()" id="mobu" class="bi bi-list mobile-nav-toggle1 d-xl-none"></i>
  <header id="header1" class="d-flex flex-column justify-content-center">

    <nav id="navbar1" class="navbar1 nav-menu1">
      <ul>
        <li><a href="/card-creator#profile" class="nav-link scrollto active"><i class="bx bx-id-card"></i> <span>Profile</span></a></li>
        <li  id="ref_nav_id"><a href="/card-creator#reference" class="nav-link scrollto"><i class="bx bx-like"></i> <span>Referral Code</span></a></li>
        <li id="ref_alt_nav_id"><a href="/card-creator#alt_reference"  class="nav-link scrollto"><i class="bx bx-like"></i> <span>Referral Code</span></a></li>
        <li><a href="/card-creator#package" class="nav-link scrollto"><i class="bx bx-coin"></i> <span>Package</span></a></li>
        <li><a href="/card-creator#basicdetails" class="nav-link scrollto"><i class="bx bx-user"></i> <span>Basic Details</span></a></li>
        <li><a href="/card-creator#social" class="nav-link scrollto"><i class="bx bx-world"></i> <span>Social Media</span></a></li>
        <li><a href="/card-creator#payment" class="nav-link scrollto"><i class="bx bx-rupee"></i> <span>Payments</span></a></li>
        <li><a href="/card-creator#pands" class="nav-link scrollto"><i class="bx bx-cart"></i> <span>Products & Services</span></a></li>
        <li><a href="/card-creator#gallery" class="nav-link scrollto"><i class="bx bx-landscape"></i> <span>Gallery</span></a></li>
        <li><a href="/card-creator#forms" class="nav-link scrollto"><i class="bx bx-mail-send"></i> <span>Enquiry Form</span></a></li>
        <li><a href="/card-creator#aboutus" class="nav-link scrollto"><i class="bx bx-medal"></i> <span>About Us</span></a></li>
        <li><a href="/card-creator#themes" class="nav-link scrollto"><i class="bx bx-paint-roll"></i> <span>Themes</span></a></li>
        <li><a href="/card-creator#pay" class="nav-link scrollto"><i class="bx bx-money"></i> <span>Pay</span></a></li>
        <li><a href="/card-creator#link" class="nav-link scrollto"><i class="bx bx-rocket"></i> <span>Link</span></a></li>
        <!-- <li><a href="/card-creator#" class="nav-link scrollto"><i (click)="logout()" class="bx bx-log-out"></i> <span>Logout</span></a></li> -->
      </ul>
    </nav>

  </header>

 <section id="profile" class="d-flex flex-column justify-content-center">
    <div class="container" data-aos="zoom-in" data-aos-delay="100" *ngIf="firebaseService.userData as user">
      <h1>{{(username) ? username : 'Super Admin'}}</h1>
      <div class="social-links">
        <a href="#" class="twitter"><i class="bx bx-phone"></i>{{phone}}</a>
        <a href="#" class="facebook"><i class="bx bx-envelope">{{user.email}}</i></a>
      </div>
    </div>
  </section>




  </main>
  <section id="reference" class="contact">
    <div class="container" data-aos="fade-up">

      <div class="section-title">
        <h2>Reference Code</h2>

      </div>

      <div class="row mt-1">

        <div class="col-lg-12 mt-5 mt-lg-0">

          <form (ngSubmit)="reference_code(referenceForm.value)" [formGroup]="referenceForm" class="php-email-form">
            <div class="row">
              <div class="col-md-12 form-group">
                <input type="text" name="refcode" class="form-control" id="refcode" formControlName="refcode" placeholder="Reference Code" required>
              </div>
            </div>
            <div class="my-3">
              <div id="succ" class="display_none">Details Saved Successfully. Thank you!</div>
            </div>
            <div class="text-center"><button type="submit"  [disabled]="!referenceForm.valid" >Save</button></div>
          </form>

        </div>

      </div>

    </div>
  </section>
  <section id="alt_reference" class="contact">
    <div class="container" data-aos="fade-up">

      <div class="section-title">
        <h2>Reference Code</h2>

      </div>

      <div class="row mt-1">

        <div class="col-lg-12 mt-5 mt-lg-0">

            <div class="row">
              <div class="col-md-12 form-group">
                <h2>Entered Reference Code Is</h2>&nbsp;{{if_reference_code_exist}}
              </div>
            </div>

        </div>

      </div>

    </div>
  </section>

  <section id="package" class="contact">
    <div class="container" data-aos="fade-up">

      <div class="section-title">
        <h2>Select Package</h2>
        <p>Trail version of your card will be upto 14 days available from your signup.. kindly select your yearly pack</p>

      </div>

      <div class="row mt-1">

        <div class="col-lg-12 mt-5 mt-lg-0">

          <form (ngSubmit)="pack_det(packForm.value)" [formGroup]="packForm" class="php-email-form">
            <div class="row">
              <div class="col-md-12 form-group">

                <select name="pack" #pack id="pack" formControlName="pack" class="form-control" >
                  <option value="0"></option>
                  <option value="basic">Basic (Rs-299/Yr)</option>
                  <option value="business">Business (Rs-499/Yr)</option>
                  <option value="professional">Professional (Rs-699/Yr)</option>
                </select>
              </div>
            </div>
            <div class="my-3">
              <div id="pack-succ" class="display_none">Details Saved Successfully. Thank you!</div>
            </div>
            <div class="text-center"><button type="submit"  [disabled]="!packForm.valid" >Save</button></div>
          </form>

        </div>

      </div>

    </div>
  </section>




  <section id="basicdetails" class="contact">
      <div class="container" data-aos="fade-up">

        <div class="section-title">
          <h2>Basic Details</h2>
          <p>Please Save each and Every Section details.</p>

        </div>

        <div class="row mt-1">

          <div class="col-lg-12 mt-5 mt-lg-0 php-email-form">

              <div class="row">
                <div class="col-md-3 form-group">
                  <input type="file" (change)="selectFile($event)" name="profimage" class="form-control" id="profimage" required>
                </div>
                <div class="col-md-3 form-group">
                  <button class="btn btn-success" [disabled]="!selectedFiles" (click)="upload()">Upload</button>
                </div>
                <div class="col-md-3 form-group">
                  <div *ngIf="currentFileUpload" class="progress">
                    <div class="progress-bar progress-bar-info progress-bar-striped" style="width: 100%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
                         role="progressbar" attr.aria-valuenow="{{percentage}}"
                         aria-valuemin="0" aria-valuemax="100">
                      {{percentage}}%
                    </div>
                  </div>
                 </div>
                 <div class="col-md-3 form-group">
                  <img src={{profileurl}} alt="profile" class="img-prof"/>

                </div>

                <div class="col-md-4 form-group">
                  <input type="text" name="fname" #bfname  value={{userfirstname}}  class="form-control" id="fname" placeholder="First Name" required>
                </div>
                <div class="col-md-4 form-group">
                  <input type="text" name="mname" #bmname  value={{usermiddlename}} class="form-control" id="mname" placeholder="Middle Name" required>
                </div>
                <div class="col-md-4 form-group">
                  <input type="text" name="lname" #blastname  value={{userlastname}} class="form-control" id="lname" placeholder="Last Name" required>
                </div>
              </div>
              <div class="form-group mt-3">
                <input type="text" class="form-control" #bpord name="pord" value={{posdesig}}  id="pord" placeholder="Position/ Designation" required>
              </div>
              <div class="form-group mt-3">
                <input type="text" class="form-control" #bcname name="cname" value={{companyname}}  id="cname" placeholder="Company Name" required>
              </div>
              <div class="form-group mt-3">
                <input type="text" class="form-control" #bnbus name="nbus" value={{natureofbusiness}} id="nbus" placeholder="Nature of Business" required>
              </div>
              <div class="form-group mt-3">
                <textarea class="form-control" #baddress name="address" value={{address}} rows="5" id="address" placeholder="Address" required></textarea>
              </div>
              <div class="form-group mt-3">
                <input type="text" class="form-control" #bphoneshow name="ph" value={{phoneshow}}  id="ph" placeholder="Phone Number" required>
              </div>
              <div class="form-group mt-3">
                <input type="text" class="form-control" #baph name="aph" value={{aphone}} id="aph" placeholder="Alternative Number" required>
              </div>
              <div class="form-group mt-3">
                <input type="text" class="form-control" #ll name="ll" value={{landline}} id="ll" placeholder="Landline Number" required>
              </div>
              <div class="form-group mt-3">
                <input type="text" class="form-control" #em name="em" value={{email}} id="em" placeholder="Email" required>
              </div>
              <div class="form-group mt-3">
                <input type="text" class="form-control" #wa name="wa" value={{whatsapp}} id="wa" placeholder="Whatsapp Number" required>
              </div>

              <div class="form-group mt-3">
                <input type="text" class="form-control" #ws name="ws" value={{website}} id="ws" placeholder="Website" required>
              </div>

              <div class="my-3">
                <div class="error-message"></div>
                <div id="bs-succ" class="display_none">Details Saved Successfully. Thank you!</div>
              </div>
              <div class="text-center">
                <button type="submit" (click)="basic_alt_det(bfname.value,bmname.value,blastname.value,bpord.value,bcname.value,bnbus.value,baddress.value,bphoneshow.value,baph.value,ll.value,em.value,wa.value,ws.value)">Save</button></div>

          </div>

        </div>

      </div>
    </section>
    <section id="social" class="contact">
      <div class="container" data-aos="fade-up">

        <div class="section-title">
          <h2>Social Media Integration</h2>
          <p>Please Save each and Every Section details.</p>

        </div>

        <div class="row mt-1">

          <div class="col-lg-12 mt-5 mt-lg-0 php-email-form">

              <div class="row">
                <div class="col-md-6 form-group">
                  <input type="text" #fblink name="fblink" value={{facebook}} class="form-control" id="fblink" placeholder="Facebook Link" required>
                </div>
                <div class="col-md-6 form-group">
                  <input type="text" #insta name="insta" value={{instagram}} class="form-control" id="insta" placeholder="Instagram Link" required>
                </div>
                <div class="col-md-6 form-group">
                  <input type="text" #mes name="mes" value={{messenger}} class="form-control" id="mes" placeholder="Messenger Link" required>
                </div>
                <div class="col-md-6 form-group">
                  <input type="text" #twit name="twit" value={{twitter}} class="form-control" id="twit" placeholder="Twitter Link" required>
                </div>
                <div class="col-md-6 form-group">
                  <input type="text" #yt name="yt" value={{youtube}} class="form-control" id="yt" placeholder="Youtube Link" required>
                </div>
                <div class="col-md-6 form-group">
                  <input type="text" #liin name="liin" value={{linkedin}} class="form-control" id="liin" placeholder="Linkedin Link" required>
                </div>
                <div class="col-md-6 form-group">
                  <input type="text" #tele name="tele" value={{telegram}} class="form-control" id="tele" placeholder="Telegram Number" required>
                </div>
              <div class="my-3">
                <div class="error-message"></div>
                <div id="smi-succ" class="display_none">Details Saved Successfully. Thank you!</div>
              </div>
              <div class="text-center"><button type="submit" (click)="smi_det(fblink.value,insta.value, mes.value,twit.value,yt.value,liin.value,tele.value)">Save</button></div>
              </div>

          </div>

        </div>

      </div>
    </section>


    <section id="payment" class="contact">
      <div class="container" data-aos="fade-up">

        <div class="section-title">
          <h2>Payments Integration</h2>
          <p>Please Save each and Every Section details.</p>

        </div>

        <div class="row mt-1">

          <div class="col-lg-12 mt-5 mt-lg-0 php-email-form">

              <div class="row">
                <div class="col-md-3 form-group">
                  <input type="text" name="gpayname" #gpaynme value={{gpayname}} class="form-control" id="gpayname" placeholder="Gpay User Name" required>
                </div>
                <div class="col-md-3 form-group">
                  <input type="text" name="gpay" #gpy value={{gpay}} class="form-control" id="gpay" placeholder="UPI ID" required>
                </div>
                <div class="col-md-3 form-group">
                  <input type="text" name="phpename" value={{phonepename}} #phpename class="form-control" id="phpename" placeholder="Phonepe User Name" required>
                </div>
                <div class="col-md-3 form-group">
                  <input type="text" name="phpe" #phpe value={{phonepe}} class="form-control" id="phpe" placeholder="PhonePe UPI ID" required>
                </div>
          <p>Bank Account details.</p>

                <div class="col-md-6 form-group">
                  <input type="text" name="bankname" #bnkname value={{bankname}} class="form-control" id="bankname" placeholder="Bank Name" required>
                </div>
                <div class="col-md-6 form-group">
                  <input type="text" name="accholname" #accholname value={{accountholdername}} class="form-control" id="accholname" placeholder="Account Holder Name" required>
                </div>
                <div class="col-md-6 form-group">
                  <input type="text" name="accnu" #acctnumber value={{accountnumber}} class="form-control" id="accnu" placeholder="Account Number" required>
                </div>
                <div class="col-md-6 form-group">
                  <input type="text" name="ifsc" #ifc value={{ifsc}} class="form-control" id="ifsc" placeholder="IFSC Code" required>
                </div>
                <div class="col-md-6 form-group">
                  <input type="text" name="sorc" #sct value={{savingscurrent}} class="form-control" id="sorc" placeholder="Savings/ Current" required>
                </div>
              <div class="my-3">
                <div class="error-message"></div>
                <div  id="pay-succ" class="display_none">Details Saved Successfully. Thank you!</div>
              </div>
              <div class="text-center">
                <button type="submit" (click)="payment_det(gpaynme.value,gpy.value,phpename.value,phpe.value,bnkname.value,accholname.value,acctnumber.value,ifc.value,sct.value)">Save</button></div>
              </div>

          </div>

        </div>

      </div>
    </section>
    <section id="pands" class="contact">
      <div class="container" data-aos="fade-up">

        <div class="section-title">
          <h2>Products &amp; Services</h2>
          <p>Please Save each and Every Section details.</p>

        </div>

        <div class="row mt-1">

          <div id="basicpandsbasic" class="col-lg-12 mt-5 mt-lg-0" >
<!-- basic cards -->
            <form action="forms/contact.php" method="post" role="form" class="php-email-form" *ngFor="let rownobasic of rowbasic">
                <input type="hidden" #pandstemp name="rownopandsbasic" class="form-control" id="rownopandsbasic" value={{rownobasic.rowno}} required>
              <div class="row">
                <div class="col-md-3 form-group">
                  <input type="file" (change)="pands_selectFile($event)" name="pandsatt" class="form-control" id="pandsatt" required>
                </div>
                <div class="col-md-3 form-group">
                  <input type="text" #pandsname name="pname" class="form-control" id="pname" placeholder="Product/Service Name" required>
                </div>
                <div class="col-md-3 form-group">
                  <input type="text" #pandsprice name="pprice" class="form-control" id="pprice" placeholder="Product/Service Price" required>
                </div>
              <div class="col-md-3 form-group">
              <div class="text-center"><button (click)='click_event_but(pandstemp.value,pandsname.value,pandsprice.value)' type="submit">Save</button></div>
              </div>
            </div>
              <div class="my-3">
                <div class="error-message"></div>
                <div class="sent-message">Details Saved Successfully. Thank you!</div>
              </div>
            </form>
            </div>
          <div id="busipandsbusiness" class="col-lg-12 mt-5 mt-lg-0">
<!-- business cards -->
<form action="forms/contact.php" method="post" role="form" class="php-email-form" *ngFor="let rownobusiness of rowbusiness">
  <input type="hidden" #pandsbustemp name="rownopandsbusiness" class="form-control" id="rownopandsbusiness" value={{rownobusiness.rowno}} required>
<div class="row">
  <div class="col-md-3 form-group">
    <input type="file" (change)="pands_selectFile($event)" name="pandsattbus" class="form-control" id="pandsattbus" required>
  </div>
  <div class="col-md-3 form-group">
    <input type="text" #pandsbusname name="pnamebus" class="form-control" id="pnamebus" placeholder="Product/Service Name" required>
  </div>
  <div class="col-md-3 form-group">
    <input type="text" #pandsbusprice name="pprice" class="form-control" id="pprice" placeholder="Product/Service Price" required>
  </div>
<div class="col-md-3 form-group">
<div class="text-center"><button (click)='click_event_but(pandsbustemp.value,pandsbusname.value,pandsbusprice.value)' type="submit">Save</button></div>
</div>
</div>
<div class="my-3">
  <div class="error-message"></div>
  <div class="sent-message">Details Saved Successfully. Thank you!</div>
</div>
</form>
</div>
<div id="profpandsprof" class="col-lg-12 mt-5 mt-lg-0" >
<!-- professional cards -->
<form action="forms/contact.php" method="post" role="form" class="php-email-form" *ngFor="let rownoprof of rowprof">
  <input type="hidden" #pandsproftemp name="rownopandsprof" class="form-control" id="rownopandsprof" value={{rownoprof.rowno}} required>
<div class="row">
  <div class="col-md-3 form-group">
    <input type="file" (change)="pands_selectFile($event)" name="pandsatt" class="form-control" id="pandsatt" required>
  </div>
  <div class="col-md-3 form-group">
    <input type="text" #pandsprofname name="pname" class="form-control" id="pname" placeholder="Product/Service Name" required>
  </div>
  <div class="col-md-3 form-group">
    <input type="text" #pandsprofprice name="pprice" class="form-control" id="pprice" placeholder="Product/Service Price" required>
  </div>
<div class="col-md-3 form-group">
<div class="text-center"><button (click)='click_event_but(pandsproftemp.value,pandsprofname.value,pandsprofprice.value)' type="submit">Save</button></div>
</div>
</div>
<div class="my-3">
  <div class="error-message"></div>
  <div class="sent-message">Details Saved Successfully. Thank you!</div>
</div>
</form>
          </div>

        </div>

      </div>
    </section>
    <section id="gallery" class="contact">
      <div class="container" data-aos="">

        <div class="section-title">
          <h2>Gallery</h2>

        </div>

        <div class="row mt-1">
<!-- basic -->
          <div  id="profbasicgal"  class="col-lg-12 mt-5 mt-lg-0">

            <form action="forms/contact.php" method="post" role="form" class="php-email-form" *ngFor="let rownogalbasic of rowgalbasic">
              <input type="hidden"  #galbasictemp  name="rownogalbasic" class="form-control" id="rownogalbasic" value={{rownogalbasic.rowno}} required>
              <div class="row">
                <div class="col-md-4 form-group">
                  <input type="file" (change)="gal_selectFile($event)" name="galimage" class="form-control" id="galimage" required>
                </div>
                <div class="col-md-4 form-group">
                  <div class="text-center"><button (click)='click_event_gal(galbasictemp.value)' type="submit">Save</button></div>
                </div>
                <div class="col-md-4 form-group">
                </div>
              </div>
              <div class="my-3">
                <div class="error-message"></div>
                <div class="sent-message">Details Saved Successfully. Thank you!</div>
              </div>
            </form>

          </div>
<!-- business -->
<div  id="profbusgal"  class="col-lg-12 mt-5 mt-lg-0">

  <form action="forms/contact.php" method="post" role="form" class="php-email-form" *ngFor="let rownogalbus of rowgalbus">
    <input type="hidden" #galbustemp name="rownogalbus" class="form-control" id="rownogalbus" value={{rownogalbus.rowno}} required>
    <div class="row">
      <div class="col-md-4 form-group">
        <input type="file" (change)="gal_selectFile($event)" name="galimage" class="form-control" id="galimage" required>
      </div>
      <div class="col-md-4 form-group">
        <div class="text-center"><button (click)='click_event_gal(galbustemp.value)' type="submit">Save</button></div>
      </div>
      <div class="col-md-4 form-group">
      </div>
    </div>
    <div class="my-3">
      <div class="error-message"></div>
      <div class="sent-message">Details Saved Successfully. Thank you!</div>
    </div>
  </form>

</div>
<!-- professional -->
<div  id="profprofgal"  class="col-lg-12 mt-5 mt-lg-0">

  <form action="forms/contact.php" method="post" role="form" class="php-email-form" *ngFor="let rownogalprof of rowgalprof">
    <input type="hidden" #galproftemp name="rownogalprof" class="form-control" id="rownogalprof" value={{rownogalprof.rowno}} required>
    <div class="row">
      <div class="col-md-4 form-group">
        <input type="file" (change)="gal_selectFile($event)" name="galimage" class="form-control" id="galimage" required>
      </div>
      <div class="col-md-4 form-group">
        <div class="text-center"><button (click)='click_event_gal(galproftemp.value)' type="submit">Save</button></div>
      </div>
      <div class="col-md-4 form-group">
      </div>
    </div>
    <div class="my-3">
      <div class="error-message"></div>
      <div class="sent-message">Details Saved Successfully. Thank you!</div>
    </div>
  </form>

</div>
        </div>

      </div>
    </section>

    <section id="forms" class="contact">
      <div class="container" data-aos="">

        <div class="section-title">
          <h2>Enquiry Form</h2>
          <p>Please Save each and Every Section details.</p>

        </div>

        <div class="row mt-1">

          <div class="col-lg-12 mt-5 mt-lg-0">

            <form (ngSubmit)="enq_det(enqForm.value)" [formGroup]="enqForm" class="php-email-form">
              <div class="row">
                <div class="col-md-12 form-group">
                  <input type="text" name="enmail" value={{enemail}} formControlName="enmail" class="form-control" id="enmail" placeholder="Email" required>
                </div>
              <div class="my-3">
                <div class="error-message"></div>
                <div id="enq-succ" class="display_none">Details Saved Successfully. Thank you!</div>
              </div>
              <div class="text-center"><button type="submit">Save</button></div>
              </div>
            </form>

          </div>

        </div>

      </div>
    </section>


    <section id="aboutus" class="contact">
      <div class="container" data-aos="">

        <div class="section-title">
          <h2>About Us</h2>

        </div>

        <div class="row mt-1">

          <div class="col-lg-12 mt-5 mt-lg-0">

            <form (ngSubmit)="aboutus_det(aboutForm.value)" [formGroup]="aboutForm" class="php-email-form">
              <div class="row">
                <div class="col-md-12 form-group">

                  <div class="form-group mt-3">
                    <textarea class="form-control" value={{abtus}} name="aboutusfield" formControlName="aboutusfield" rows="5" id="aboutusfield" placeholder="Details about you/ your business" required></textarea>
                  </div>
                </div>
              </div>
              <div class="my-3">
                <div id="aboutus-succ" class="display_none">Details Saved Successfully. Thank you!</div>
              </div>
              <div class="text-center"><button type="submit"  [disabled]="!aboutForm.valid" >Save</button></div>
            </form>

          </div>

        </div>

      </div>
    </section>
    <section id="themes" class="pricing">
      <div class="container" data-aos="">

        <div class="section-title">
          <h2>Themes</h2>

        </div>

        <div class="row mt-1">

          <div class="col-lg-12 mt-5 mt-lg-0" *ngIf="firebaseService.userData as user">
            <p>Basic</p>
<input type="radio" nmae="theme1" id="theme1" value="b1"/><a target="blank" href="http://localhost:4200/b1?:user={{user.email}}">http://localhost:4200/b1?:user={{user.email}}</a>
<input type="radio" nmae="theme1" id="theme1" value="b1"/><a target="blank" href="http://localhost:4200/b2?:user={{user.email}}">http://localhost:4200/b2?:user={{user.email}}</a>
<input type="radio" nmae="theme1" id="theme1" value="b1"/><a target="blank" href="http://localhost:4200/b3?:user={{user.email}}">http://localhost:4200/b3?:user={{user.email}}</a>
<p>Professional</p>
<input type="radio" nmae="theme1" id="theme1" value="b1"/><a target="blank" href="http://localhost:4200/pr1?:user={{user.email}}">http://localhost:4200/pr1?:user={{user.email}}</a>
<input type="radio" nmae="theme1" id="theme1" value="b1"/><a target="blank" href="http://localhost:4200/pr2?:user={{user.email}}">http://localhost:4200/pr2?:user={{user.email}}</a>
<input type="radio" nmae="theme1" id="theme1" value="b1"/><a target="blank" href="http://localhost:4200/pr3?:user={{user.email}}">http://localhost:4200/pr3?:user={{user.email}}</a>
<p>Business</p>
<input type="radio" nmae="theme1" id="theme1" value="b1"/><a target="blank" href="http://localhost:4200/bs1?:user={{user.email}}">http://localhost:4200/bs1?:user={{user.email}}</a>
<input type="radio" nmae="theme1" id="theme1" value="b1"/><a target="blank" href="http://localhost:4200/bs2?:user={{user.email}}">http://localhost:4200/bs2?:user={{user.email}}</a>
<input type="radio" nmae="theme1" id="theme1" value="b1"/><a target="blank" href="http://localhost:4200/bs3?:user={{user.email}}">http://localhost:4200/bs3?:user={{user.email}}</a>

          </div></div></div></section>


    <section id="pay" class="pricing">
      <div class="container" data-aos="">

        <div class="section-title">
          <h2>Pay for Year</h2>

        </div>

        <div class="row mt-1">

          <div class="col-lg-12 mt-5 mt-lg-0">

              <div class="row">

      <div class="col-lg-4" data-aos="" data-aos-delay="100">
        <div class="box">
          <h3>Basic Plan</h3>
          <h4><sup>Rs</sup>299<span>per year</span></h4>
          <ul>
            <li><i class="bx bx-check"></i> Basic Details</li>
            <li><i class="bx bx-check"></i> Social Media Integration</li>
            <li><i class="bx bx-check"></i> Payment Integration</li>
            <li><i class="bx bx-check"></i> 10 Gallery Images</li>
            <li><i class="bx bx-check"></i> Products List</li>
            <li class="na"><i class="bx bx-x"></i> <span>Enquiry Forms</span></li>
          </ul>
          <!-- <a href="https://rzp.io/l/D0j3MeB" class="buy-btn">Get Started</a> -->
          <i (click)="payment()" class="buy-btn"><span>Get Started</span></i>

        </div>
      </div>

      <div class="col-lg-4 mt-4 mt-lg-0" data-aos="" data-aos-delay="200">
        <div class="box featured">
          <h3>Professional Plan</h3>
          <h4><sup>Rs</sup>499<span>per year</span></h4>
          <ul>
            <li><i class="bx bx-check"></i> Basic Details</li>
            <li><i class="bx bx-check"></i> Social Media Integration</li>
            <li><i class="bx bx-check"></i> Payment Integration</li>
            <li><i class="bx bx-check"></i> 25 Gallery Images</li>
            <li><i class="bx bx-check"></i> Products/Service Attachments</li>
            <li><i class="bx bx-check"></i> About Us</li>
            <li><i class="bx bx-check"></i> Enquiry Forms</li>


          </ul>
          <a href="https://rzp.io/l/M93HSKB" class="buy-btn">Get Started</a>
        </div>
      </div>

      <div class="col-lg-4 mt-4 mt-lg-0" data-aos="" data-aos-delay="300">
        <div class="box">
          <h3>Business Plan</h3>
          <h4><sup>Rs</sup>699<span>per year</span></h4>
          <ul>
            <li><i class="bx bx-check"></i> Basic Details</li>
            <li><i class="bx bx-check"></i> Social Media Integration</li>
            <li><i class="bx bx-check"></i> Payment Integration</li>
            <li><i class="bx bx-check"></i> 50 Gallery Images</li>
            <li><i class="bx bx-check"></i> Products/Service Attachments</li>
            <li><i class="bx bx-check"></i> About Us</li>
            <li><i class="bx bx-check"></i> Enquiry Forms</li>
          </ul>
          <a href="https://rzp.io/l/zDH8suJxmY" class="buy-btn">Get Started</a>
        </div>
      </div>
</div></div></div></div></section>
<section id="link" class="pricing">
  <div class="container" data-aos="">

    <div class="section-title">
      <h2>Link to Share</h2>

    </div>

    <div class="row mt-1">

      <div class="col-lg-12 mt-5 mt-lg-0" *ngIf="firebaseService.userData as user">
        <a href="http://localhost:4200/b1?:user={{user.email}}">http://localhost:4200/b1?:user={{user.email}}</a>


      </div></div></div></section>
<section id="logout" class="logout">
  <div>
  <a href="/login" class="logout-bottom d-flex align-items-center justify-content-center"><i tooltip="Logout" (click)="logout()" class="bx bx-log-out"></i></a>
  </div>
  </section>
